import { sendToLurker as p } from "../../Lurker/Lurker.js";
var b = Object.defineProperty,
  t = Object.getOwnPropertySymbols,
  d = Object.prototype.hasOwnProperty,
  v = Object.prototype.propertyIsEnumerable,
  i = (o, e, a) => e in o ? b(o, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: a
  }) : o[e] = a,
  g = (o, e) => {
    for (var a in e || (e = {})) d.call(e, a) && i(o, a, e[a]);
    if (t) for (var a of t(e)) v.call(e, a) && i(o, a, e[a]);
    return o;
  };
const l = (o, e) => {
    var a, r, n;
    p({
      eventType: o,
      objectDetail: "tooltip",
      objectName: "onboarding_nav_pro",
      data: g({
        page_name: (n = (r = (a = window == null ? void 0 : window.dataLayer) == null ? void 0 : a[0]) == null ? void 0 : r.page) == null ? void 0 : n.pageType
      }, e)
    });
  },
  s = o => {
    l("error", {
      message: o
    });
  },
  u = (o, e, a, r) => ({
    login: e,
    isAutosPro: o,
    hasNavbar: a,
    menuPro: r
  });
export { u as getOnboardingExtraData, s as sendErrorOnboardingEvent, l as sendOnboardingEvent };